import axios from 'axios';

const token = document.querySelector('meta[name="csrf-token"]')?.content;

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default axios;
